import React from 'react';
import { Drawer, DrawerHeader } from '@noths/polaris-client-ribbons-design-system';
import { Button } from '@noths/polaris-design-system-core-components';

import { resolveFacetOptionsComponent } from 'src/components/organisms/ListingsControlsOptions/resolveFacetOptionsComponent';
import type { UIFacet } from 'src/components/types/UIFacet';
import * as styles from './FacetDrawer.styles';

export interface FacetDrawerProps {
  ctaDisabled?: boolean;
  ctaText: string;
  facet: UIFacet | null;
  isOpen: boolean;
  loading: boolean;
  onAfterClose?: () => void;
  /** Dismissal: the X, the overlay or Escape. Distinct from applying via the CTA. */
  onClose: () => void;
  onViewResults: () => void;
}

export const FacetDrawer = ({
  ctaDisabled = false,
  ctaText,
  facet,
  isOpen,
  loading,
  onAfterClose,
  onClose,
  onViewResults,
}: FacetDrawerProps) => {
  const FacetOptionsComponent = facet ? resolveFacetOptionsComponent(facet) : null;

  return (
    <Drawer
      contentContainerStyles={styles.drawerRoot}
      contentLabel={facet ? `${facet.title} filter options` : 'Filter options'}
      isOpen={isOpen}
      onAfterClose={onAfterClose}
      onOverlayClick={onClose}
      onRequestClose={onClose}
      panelSize="full"
      transitionFrom="bottom"
    >
      {facet && FacetOptionsComponent && (
        <>
          <div css={styles.drawerHeader}>
            <DrawerHeader headingLevel="h2" onClose={onClose} title={facet.title} />
          </div>
          <div css={styles.drawerBody}>
            <FacetOptionsComponent facet={facet} />
          </div>
          <div css={styles.drawerFooter}>
            <Button disabled={ctaDisabled} fullWidth onClick={onViewResults}>
              {loading ? 'Updating...' : ctaText}
            </Button>
          </div>
        </>
      )}
    </Drawer>
  );
};
